
import { createApiClient } from 'Network/ApiClient';

export const DrugNotAllowedwithActivityAxiosInstance = createApiClient('DrugsNotAllowedActivity/');


